import { gql } from "graphql-request";

const SERVER_DELETE_EVALUATION_PROCESS = gql`
  mutation SERVER_DeleteEvaluationProcess($id: ID!) {
    deleteEvaluationProcess(id: $id)
  }
`;
export default SERVER_DELETE_EVALUATION_PROCESS;